export function sessionRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_SESSION_START":           
        case "FETCH_SESSIONS_START":                                 
        case "FETCH_CURRENT_SESSION_START":                                 
        case "UPDATE_SESSION_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_SESSION_FULFILLED":           
        case "FETCH_SESSIONS_FULFILLED":                                 
        case "FETCH_CURRENT_SESSION_FULFILLED":                                 
        case "UPDATE_SESSION_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_SESSION_ERROR":
        case "FETCH_SESSIONS_ERROR":
        case "FETCH_CURRENT_SESSION_ERROR":
        case "UPDATE_SESSION_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}